module.exports = __webpack_public_path__ + "img/tu_11.6f2e3610.jpg";